import { TaskQueue } from 'packages/task-man/service/pickup/task-queue';
import useSWRImmutable from 'swr/immutable';
import { multitaskBatchIDAtom } from 'packages/at-shell/state/recoil/ui';
import { useRecoilValue } from 'recoil';
import { swrKey } from 'packages/task-man/service/pickup/use-task-queue';

/** Important: for returned mutateAssignedTasks() to work, you MUST pass in a valid taskQueue. This tends to not work so well.
 * Instead: to trigger a load of the next batch of tasks, increment multitaskBatchIDAtom. This is used to invalidate
 * useSWR's cache and trigger a reload.
 */
export const useTasksByObjectToken = (
  taskQueue: TaskQueue | undefined,
  objectToken: string | null | undefined
) => {
  const multitaskBatchID = useRecoilValue(multitaskBatchIDAtom);

  return useSWRImmutable(
    taskQueue && objectToken
      ? swrKey(taskQueue, multitaskBatchID, `tasksByObjectToken/${objectToken}`)
      : null,
    () => taskQueue?.getTasksByObjectToken(objectToken as string)
  );
};
